import { chatbotHost, restHost } from '../../apiConfig';

export const chatbotConfig = {
  CHAT_INITIATE_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/chat_initiate`
    : '',
  CHAT_RESPONSE_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/get_chat_response`
    : '',
  CHAT_HISTORY_API_URL: chatbotHost
    ? `https://${chatbotHost}/api/v1/History`
    : '',
  REACTION_API_URL: restHost
    ? `https://${restHost}/customers/chat_reactions`
    : '',
};
